import VerificationGuardPanel from './VerificationGuardPanel';
import './style/index.less';

export default VerificationGuardPanel;
